export default {
  KKDAY_REPORT_TRANSACTION_ORDER_STATUS: {
    BACK: 'BACK',
    CANCLE: 'CX',
    GO: 'GO'
  }
}
